export const TOGGLE_STREET_PARKING = 'toggle-street-parking';
const toggleStreetParking = ({ showStreetParking }) => ({
  type: TOGGLE_STREET_PARKING,
  payload: { showStreetParking },
});
export default toggleStreetParking;
